// WhatsApp do suporte: o mesmo numero publico da pagina de vendas. Mora num
// lugar so porque aparece na tela de assinatura inativa e no Guia (Ajuda).
export const WHATSAPP_DO_SUPORTE = 'https://wa.me/5521995411263'
